import {Injectable} from '@angular/core';
import {NewBuilderTourEnum} from "../builder-tour.enum";

@Injectable({
  providedIn: 'root'
})
export class CanvasTourService {
  _shownTour = {
    [NewBuilderTourEnum.ADD_SECTION_BTN]: false,
    [NewBuilderTourEnum.ADD_SECTION_LIST]: false,
    [NewBuilderTourEnum.EDIT_SECTION]: false,
    [NewBuilderTourEnum.ADD_PAGE]: false,
  };

  setTour(step, value) {
    this.shownTour = {...this.shownTour, [step]: value};
  }

  set shownTour(tour) {
    localStorage.setItem('shownTour', JSON.stringify(tour));
    this._shownTour = tour;
  }

  get shownTour() {
    const tour = JSON.parse(localStorage.getItem('shownTour'));
    if (tour) {
      this._shownTour = tour;
      return tour;
    }
    return this._shownTour;
  }


  constructor() {
  }
}
